module.exports = __webpack_public_path__ + "static/07_nataliya_fiala-c63277824fd47b14ce7dd73542d13ef7.jpg";